export default __webpack_public_path__ + "static/media/logo.adc83c43.png";